import { db } from "../Config";

/**
 * Guarda el objeto de configuración del wizard en Firestore.
 * @param {Object} wizardObj - Objeto con estructura { empresaId, steps }
 * @returns {Promise<void>}
 */
export const saveWizardConfig = async (wizardObj) => {
  if (!wizardObj.empresaId) throw new Error("empresaId es requerido");
  await db
    .collection("empresas")
    .doc(wizardObj.empresaId)
    .collection("wizardConfig")
    .doc(wizardObj.empresaId) // or "default" or whatever, keeping previous logic of doc(id)
    .set(wizardObj, { merge: true });
};

/**
 * Lee el objeto de configuración del wizard desde Firestore.
 * @param {string} empresaId
 * @returns {Promise<Object|null>} El objeto guardado o null si no existe
 */
export const getWizardConfig = async (empresaId) => {
  if (!empresaId) throw new Error("empresaId es requerido");
  const doc = await db
    .collection("empresas")
    .doc(empresaId)
    .collection("wizardConfig")
    .doc(empresaId)
    .get();
  return doc.exists ? doc.data() : null;
};